// extracted by mini-css-extract-plugin
module.exports = {"marketplaceLayout":"_2_H9X"};